import React, { useEffect, useState, useContext } from 'react';
import { MediaUploader, message } from '@tencent/spaui';
import { RegistContext } from '../context';
// @ts-ignore
import watermark from 'blind-watermark';

const beforeUpload = (file: any, next: any) => {
  // return Promise.resolve(next());
  if (!file.type.includes('gif')) {
    return watermark
      .addWm({
        originImg: file,
        wmType: 'string',
        wm: '腾讯ISV',
        download: false,
        name: `${file.name.split('.')[0]}.png`,
      })
      .then((val: any) => {
        next({}, val.File);
      })
      .catch((e: any) => {
        console.log('wm failed:', e);
        next();
      });
  }
  return Promise.resolve(next());
};

// 遮罩上面的按钮
const ActionComponent = (props: any = {}) => {
  const { className, triggerUpload } = props;

  return (
    <div className={className}>
      <div className="spaui-upmedia-toolbar">
        {/* <div className='spaui-upmedia-toolbar-left'>*/}
        {/* <label className='spaui-checkbox'><input type='checkbox' className='check' value='1' name='' /><span className='ico'></span></label>*/}
        {/* </div>*/}
        <div className="spaui-upmedia-toolbar-right">
          {/* <a className='spaui-upmedia-action-item spaui-upmedia-zoom' href='javascript:;' onClick={() => { alert(value.url) }}>查看</a>*/}
          <a className="spaui-upmedia-action-item spaui-upmedia-reset" href="javascript:;" onClick={triggerUpload}>
            重新上传
          </a>
        </div>
      </div>
    </div>
  );
};

// eslint-disable-next-line react/display-name
export default (props: { onDelete: () => void; onChange: (data: any) => void; value?: string; maxSize?: number }) => {
  const [value, setValue] = useState({});
  const [disabled, setDisabled] = useState(false);
  const { userIdentity } = useContext(RegistContext);

  const fileFilter = (fileInfo: File) => {
    const max = props.maxSize || 10;
    const { size } = fileInfo;

    if (size > max * 1024 * 1024) {
      message.error(`文件大小超过${max}M限制`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (props.value) {
      setValue({
        url: props.value,
        name: '',
        status: 'success',
      });
    }
  }, [props.value]);
  return (
    <MediaUploader
      accept="image/*"
      name="file"
      url="/isv_service/v1/agency/update_file"
      value={value}
      filter={fileFilter}
      disabled={disabled}
      data={{ flow_key: userIdentity }}
      onDelete={() => {
        props.onDelete();
        setValue({});
      }}
      check={(file: any, next: any) => {
        setDisabled(true);
        message.success('文件加密中，请稍候');
        beforeUpload(file, next).then(() => setDisabled(false));
      }}
      onComplete={(resp: any, fileInfo: any) => {
        const { file_url } = resp.data?.[0] || {};
        if (resp.code !== 0) {
          setValue({
            name: fileInfo.name,
            status: 'fail',
          });
          message.error(resp.msg);
        } else {
          setValue({
            url: file_url,
            name: fileInfo.name,
            status: 'success',
          });
          props.onChange(file_url);
        }
      }}
      ActionComponent={ActionComponent}
      ActionComponentProps={{
        test: 1,
      }}
    />
  );
};
